import React from "react";
import { t } from "i18next";

import userIcon from "../../../assets/icons/user.svg";
import phoneIcon from "../../../assets/icons/phone.svg";
import fileIcon from "../../../assets/icons/file.svg";
import noteIcon from "../../../assets/icons/note.svg";
import infoIcon from "../../../assets/icons/info.svg";

const NAV_ITEMS = [
    {
        key: "main",
        label: () => t("aboutUs") || "О компании",
        icon: userIcon,
    },
    {
        key: "contacts",
        label: () => t("contacts") || "Контакты",
        icon: phoneIcon,
    },
    {
        key: "policy",
        label: () => t("privacyPolicy") || "Политика конфиденциальности",
        icon: fileIcon,
    },
    {
        key: "terms",
        label: () => t("termsOfUse") || "Условия использования",
        icon: noteIcon,
    },
    {
        key: "faq",
        label: () => t("FAQ") || "FAQ",
        icon: infoIcon,
    },
];

const AboutLeftNav = ({ activeSection, handleSectionChange }) => {
    return (
        <aside className="
            sticky top-[110px] mr-5
            w-[260px] min-w-[220px] shrink-0
            bg-white rounded-2xl
            shadow-[0_2px_16px_rgba(20,127,38,0.06)]
            px-3 pt-5 pb-3 h-fit
            max-md:static max-md:w-full max-md:min-w-0 max-md:mr-0
            max-md:rounded-none max-md:shadow-none max-md:bg-transparent
            max-md:border-t max-md:border-b max-md:border-[#EDEDED]
            max-md:px-0 max-md:pt-0
        ">
            {/* Title — hidden on mobile */}
            <p className="
                text-[11px] font-bold tracking-widest uppercase
                text-[#939393] mx-2 mb-3
                max-md:hidden
            ">
                {t("navigation") || "Навигация"}
            </p>

            <nav>
                <ul className="
                    flex flex-col gap-0.5 m-0 p-0 list-none
                    max-md:flex-row max-md:overflow-x-auto max-md:overflow-y-hidden
                    max-md:gap-0 max-md:px-3 max-md:py-2.5 max-md:bg-white
                    max-md:[scrollbar-width:none] max-md:[&::-webkit-scrollbar]:hidden
                ">
                    {NAV_ITEMS.map((item) => {
                        const isActive = activeSection === item.key;
                        return (
                            <li key={item.key} className="max-md:shrink-0 max-md:[&+li]:ml-2">
                                <a
                                    href={`#${item.key}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleSectionChange(item.key);
                                    }}
                                    className={[
                                        // base
                                        "flex items-center gap-2.5 px-3 py-2.5 rounded-xl no-underline",
                                        "text-sm font-medium leading-snug cursor-pointer",
                                        "transition-all duration-150 relative",
                                        // desktop active
                                        isActive
                                            ? "bg-gradient-to-r from-[#e8f5ea] to-[#f4fbf4] text-[#147F26] font-semibold"
                                            : "text-[#222222] hover:bg-[#f0faf2] hover:text-[#147F26]",
                                        // mobile overrides
                                        "max-md:whitespace-nowrap max-md:rounded-full max-md:py-2 max-md:px-3.5",
                                        isActive
                                            ? "max-md:bg-[#147F26] max-md:text-white max-md:border max-md:border-[#147F26]"
                                            : "max-md:bg-transparent max-md:border max-md:border-[#EDEDED] max-md:text-[#222222]",
                                    ].join(" ")}
                                >
                                    {/* Active left bar — desktop only */}
                                    {isActive && (
                                        <span className="
                                            absolute left-0 top-2 bottom-2 w-[3px]
                                            bg-[#147F26] rounded-r-full
                                            max-md:hidden
                                        " />
                                    )}

                                    {/* Icon */}
                                    <img
                                        src={item.icon}
                                        alt=""
                                        width={18}
                                        height={18}
                                        className={[
                                            "shrink-0 transition-all duration-150 max-md:hidden",
                                            isActive
                                                ? "[filter:brightness(0)_saturate(100%)_invert(18%)_sepia(70%)_saturate(6415%)_hue-rotate(142deg)_brightness(93%)_contrast(84%)]"
                                                : "[filter:brightness(0)_saturate(100%)_invert(60%)_sepia(0%)_saturate(0%)_hue-rotate(0deg)_brightness(100%)_contrast(80%)]",
                                        ].join(" ")}
                                    />

                                    {/* Label */}
                                    <span className="flex-1">{item.label()}</span>

                                    {/* Chevron — desktop only */}
                                    <svg
                                        className={[
                                            "shrink-0 transition-colors duration-150 max-md:hidden",
                                            isActive ? "text-[#147F26] opacity-100" : "text-[#939393] opacity-50",
                                        ].join(" ")}
                                        width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2"
                                            strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </aside>
    );
};

export default AboutLeftNav;
